import { INTERNAL_LINKS } from '../enum';
import UserDetails from '../views/userdetails';
import CompanyDetailsView from './company-details';
import ComplianceWorklistView from './compliance-worklist';
import ComplianceWorklistDetails from './compliance-worklist-details';
import CountryRatesView from './country-rates';
import CreateCountryView from './create-country';
import CreateCountryRateView from './create-country-rate';
import CreateCustomtPayrollFileView from './create-custom-payroll-file';
import CreateDefaultPayrollFileView from './create-default-payroll-file';
import CreatePromptView from './create-prompt';
import CustomPlansView from './custom-plans';
import FAVRRatesView from './favr-rates';
import GenerateFavrRatesView from './generate-favr-rates';
import GlobalSettingsView from './global-settings';
import InsuranceCompaniesView from './insurance-companies';
import ManageSystemAdminsView from './manage-system-admins';
import PromptDetailsView from './prompt-details';
import PromptsView from './prompts';
import RateQuotesView from './rate-quotes';
import ReportsManagement from './reports-management';
import SelectCompanyView from './select-companies';
import StandardUserVehiclesView from './standard-user-vehicles';
import StandardVehiclesView from './standard-vehicles';
import SystemAdminDetails from './system-admin-details';
import TripAnomaliesView from './trip-anomalies';
import TripsWithAnomalies from './trips-with-anomalies';
import UpdateCountryView from './update-country';
import UpdateCountryRateView from './update-country-rate';
import UpdateCustomPayrollFileView from './update-custom-payroll-file';
import UpdateDefaultPayrollFileView from './update-default-payroll-file';
import UpdatePromptView from './update-prompt';

const SystemAdminViews = [
  {
    path: `${INTERNAL_LINKS.SELECT_COMPANY}/:id`,
    component: CompanyDetailsView,
  },
  {
    path: INTERNAL_LINKS.SELECT_COMPANY,
    component: SelectCompanyView,
  },
  {
    path: `${INTERNAL_LINKS.UPDATE_COUNTRY}/:id`,
    component: UpdateCountryView,
  },
  {
    path: INTERNAL_LINKS.CREATE_COUNTRY,
    component: CreateCountryView,
  },
  {
    path: `${INTERNAL_LINKS.UPDATE_COUNTRY_RATES}/:id`,
    component: UpdateCountryRateView,
  },
  {
    path: INTERNAL_LINKS.CREATE_COUNTRY_RATES,
    component: CreateCountryRateView,
  },
  {
    path: INTERNAL_LINKS.COUNTRY_RATES,
    component: CountryRatesView,
  },
  {
    path: INTERNAL_LINKS.COMPLIANCE_WORKLIST,
    component: ComplianceWorklistView,
  },
  {
    path: `${INTERNAL_LINKS.UPDATE_SYSTEM_ADMINS}/:id`,
    component: SystemAdminDetails,
  },
  {
    path: INTERNAL_LINKS.CUSTOM_PLANS,
    component: CustomPlansView,
  },
  {
    path: INTERNAL_LINKS.SYSTEM_ADMINS,
    component: ManageSystemAdminsView,
  },
  {
    path: INTERNAL_LINKS.REPORTS_MANAGEMENT,
    component: ReportsManagement,
  },
  {
    path: INTERNAL_LINKS.GLOBAL_SETTINGS,
    component: GlobalSettingsView,
  },
  {
    path: INTERNAL_LINKS.FAVR_STANDARD_VEHICLES,
    component: StandardVehiclesView,
  },
  {
    path: INTERNAL_LINKS.USER_STANDARD_VEHICLES,
    component: StandardUserVehiclesView,
  },
  {
    path: `${INTERNAL_LINKS.USER_DETAILS}/:id`,
    component: UserDetails,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.COMPLIANCE_WORKLIST_DETAILS(),
    component: ComplianceWorklistDetails,
  },
  {
    path: INTERNAL_LINKS.TRIP_ANOMALIES,
    component: TripAnomaliesView,
  },
  {
    path: INTERNAL_LINKS.TRIPS_WITH_ANOMALIES,
    component: TripsWithAnomalies,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.INSURANCE_COMPANIES,
    component: InsuranceCompaniesView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.FAVR_RATES,
    component: FAVRRatesView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.GENERATE_FAVR_RATES,
    component: GenerateFavrRatesView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.CREATE_DEFAULT_PAYROLL_FILE,
    component: CreateDefaultPayrollFileView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.UPDATE_DEFAULT_PAYROLL_FILE(),
    component: UpdateDefaultPayrollFileView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.CREATE_CUSTOM_PAYROLL_FILE(),
    component: CreateCustomtPayrollFileView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.UPDATE_CUSTOM_PAYROLL_FILE(),
    component: UpdateCustomPayrollFileView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.RATE_QUOTES,
    component: RateQuotesView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.CREATE_PROMPT,
    component: CreatePromptView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.UPDATE_PROMPT(),
    component: UpdatePromptView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.PROMPT_DETAILS(),
    component: PromptDetailsView,
  },
  {
    exact: true,
    path: INTERNAL_LINKS.PROMPTS,
    component: PromptsView,
  },
];

export default SystemAdminViews;
